// Based on https://github.com/tailwindlabs/headlessui/blob/@headlessui/react@v1.4.3/packages/@headlessui-react/src/utils/disposables.ts

import { useEffect, useState } from 'react';

export function useDisposables() {
  const [disposables] = useState(() => {
    const disposers: (() => void)[] = [];

    return {
      clear() {
        disposers.forEach(dispose => dispose());
        disposers.length = 0;
      },
      requestAnimationFrame(...args: Parameters<typeof window.requestAnimationFrame>) {
        let id = window.requestAnimationFrame(...args);
        disposers.push(() => window.cancelAnimationFrame(id));
      },
      setInterval(...args: Parameters<typeof window.setInterval>) {
        let id = window.setInterval(...args);
        disposers.push(() => window.clearInterval(id));
      },
      setTimeout(...args: Parameters<typeof window.setTimeout>) {
        let id = window.setTimeout(...args);
        disposers.push(() => window.clearTimeout(id));
      },
    };
  });

  useEffect(() => disposables.clear, [disposables]);

  return disposables;
}
